import React from 'react';
import { Route, IndexRoute } from 'react-router';
import URLHelpers from '../components/shared/url_helpers';

const {
  coreIdentityVerificationPath,
  lpIdentityVerificationPath,
  coreBankAccountVerificationPath,
  lpBankAccountVerificationPath,
  corePhotoIDVerificationPath,
  lpPhotoIDVerificationPath,
  coreCompanyDataVerificationPath,
  lpCompanyDataVerificationPath,
  coreShopOwnerVerificationPath,
  coreBankAccountPath,
  lpShopOwnerVerificationPath,
} = URLHelpers;

export const CoreIdentityVerificationRoute = (
  <Route
    key={coreIdentityVerificationPath}
    path={coreIdentityVerificationPath}
    getComponent={(_location, cb) => {
      require.ensure(
        [],
        (require) => {
          cb(null, require('../identity_verification/identity_verification_container').default);
        },
        'onboarding',
      );
    }}
  >
    <IndexRoute
      getComponent={(_location, cb) => {
        require.ensure(
          [],
          (require) => {
            cb(null, require('../identity_verification/statuses_index').default);
          },
          'onboarding',
        );
      }}
    />
    <Route
      key={coreBankAccountVerificationPath}
      path={coreBankAccountVerificationPath}
      getComponent={(_location, cb) => {
        require.ensure(
          [],
          (require) => {
            cb(null, require('../identity_verification/bank_account_verification').default);
          },
          'onboarding',
        );
      }}
    />
    <Route
      key={corePhotoIDVerificationPath}
      path={corePhotoIDVerificationPath}
      getComponent={(_location, cb) => {
        require.ensure(
          [],
          (require) => {
            cb(null, require('../identity_verification/photo_id_verification').default);
          },
          'onboarding',
        );
      }}
    />
    <Route
      key={coreShopOwnerVerificationPath}
      path={coreShopOwnerVerificationPath}
      getComponent={(_location, cb) => {
        require.ensure(
          [],
          (require) => {
            cb(null, require('../identity_verification/shop_owner_verification').default);
          },
          'onboarding',
        );
      }}
    />
    <Route
      key={coreCompanyDataVerificationPath}
      path={coreCompanyDataVerificationPath}
      getComponent={(_location, cb) => {
        require.ensure(
          [],
          (require) => {
            cb(null, require('../identity_verification/update_company_form').default);
          },
          'onboarding',
        );
      }}
    />
    <Route
      key={coreBankAccountPath}
      path={coreBankAccountPath}
      getComponent={(_location, cb) => {
        require.ensure(
          [],
          (require) => {
            cb(null, require('../identity_verification/update_bank_account_form').default);
          },
          'onboarding',
        );
      }}
    />
  </Route>
);

export const LPIdentityVerificationRoute = (
  <Route
    key={lpIdentityVerificationPath}
    path={lpIdentityVerificationPath}
    getComponent={(_location, cb) => {
      require.ensure(
        [],
        (require) => {
          cb(null, require('../identity_verification/identity_verification_container').default);
        },
        'onboarding',
      );
    }}
  >
    <IndexRoute
      getComponent={(_location, cb) => {
        require.ensure(
          [],
          (require) => {
            cb(null, require('../identity_verification/statuses_index').default);
          },
          'onboarding',
        );
      }}
    />
    <Route
      key={lpBankAccountVerificationPath}
      path={lpBankAccountVerificationPath}
      getComponent={(_location, cb) => {
        require.ensure(
          [],
          (require) => {
            cb(null, require('../identity_verification/bank_account_verification').default);
          },
          'onboarding',
        );
      }}
    />
    <Route
      key={lpPhotoIDVerificationPath}
      path={lpPhotoIDVerificationPath}
      getComponent={(_location, cb) => {
        require.ensure(
          [],
          (require) => {
            cb(null, require('../identity_verification/photo_id_verification').default);
          },
          'onboarding',
        );
      }}
    />
    <Route
      key={lpCompanyDataVerificationPath}
      path={lpCompanyDataVerificationPath}
      getComponent={(_location, cb) => {
        require.ensure(
          [],
          (require) => {
            cb(null, require('../identity_verification/update_company_form').default);
          },
          'onboarding',
        );
      }}
    />
    <Route
      key={lpShopOwnerVerificationPath}
      path={lpShopOwnerVerificationPath}
      getComponent={(_location, cb) => {
        require.ensure(
          [],
          (require) => {
            cb(null, require('../identity_verification/shop_owner_verification').default);
          },
          'onboarding',
        );
      }}
    />
  </Route>
);
